module.exports = __webpack_public_path__ + "static/Centaur-56cf75486ec648f3b0fb661fcbc2f831.jpg";